export function getCosUrl(k: string, cred: any) {
	if (k?.startsWith("http")) {
		return k
	}
	if (k?.startsWith("/") && k.includes("public") && cred && cred.publicPath) {
		const { publicPath } = cred
		return `${publicPath}${k}`
	}
	return k
}
